var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSupport = function SvgSupport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25.5C4.397.5 1.5 3.21 1.5 7.75v1.76a2.46 2.46 0 0 0-1 1.99c0 1.178.82 2.169 1.919 2.432C3.415 17.883 6.013 20.5 9 20.5A.75.75 0 1 0 9 19c-2.353 0-4.506-2.43-5.236-5.907a.75.75 0 0 0-.793-.594A1 1 0 0 1 2 11.5c0-.383.22-.723.572-.89A.75.75 0 0 0 3 9.931V8.587c1.928-.506 3.134-1.535 3.778-2.254.82.5 2.438 1.167 5.222 1.167 1.073 0 2.005-.097 2.748-.218.118.353.252.869.252 1.468v5c0 1.252-.998 2.25-2.25 2.25h-.92a1.75 1.75 0 1 0 0 1.5h.92a3.76 3.76 0 0 0 3.737-3.5h.013a2 2 0 0 0 2-2v-1a2 2 0 0 0-2-2v-.25a6.25 6.25 0 0 0-.291-1.842 1.54 1.54 0 0 0 .661-.724c.18-.407.173-.87-.018-1.268C15.51 2.109 12.738.5 9.25.5Zm-2.75 10a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm5 0a1 1 0 1 0 .004 2 1 1 0 0 0-.004-2Z",
    fill: "gray"
  })));
};

export default SvgSupport;